import { render, staticRenderFns } from "./TrendsChart.vue?vue&type=template&id=f8cdd266&scoped=true"
import script from "./TrendsChart.vue?vue&type=script&lang=js"
export * from "./TrendsChart.vue?vue&type=script&lang=js"
import style0 from "./TrendsChart.vue?vue&type=style&index=0&id=f8cdd266&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cdd266",
  null
  
)

export default component.exports